import React, { createContext, useState } from "react";

export const AppointmentContext = createContext();

export const AppointmentProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState("pageFirst");
  const [hospitalName, setHospitalName] = useState("");
  const [selectionType, setSelectionType] = useState(""); 
  const [appointmentType, setAppointmentType] = useState(""); 
  const [department, setDepartment] = useState(""); 
  const [selectedDate, setSelectedDate] = useState("");
  const [addpatient, setAddpatient] = useState("");

  const handleNavigation = (step) => {
    setCurrentStep(step);
  };

  return (
    <AppointmentContext.Provider   value={{
        currentStep,
        handleNavigation,
        hospitalName,
        setHospitalName,
          selectionType,
        setSelectionType,
        appointmentType,
        setAppointmentType,
        department,
        setDepartment,
        selectedDate,
        setSelectedDate,
        addpatient,
        setAddpatient
      }}>
        
      {children}
    </AppointmentContext.Provider>
  );
};
